import { useEffect } from 'react';
import { logger } from '@/lib/logger';

/**
 * Component that monitors browser tab visibility changes.
 * Logs when user leaves and returns to the tab for debugging purposes.
 * 
 * State persistence is handled by:
 * - React Query PersistQueryClientProvider for server data
 * - usePageState hook for UI state (filters, search, pagination)
 * - useScrollRestoration for scroll positions
 * - useFormPersistence for form drafts
 */
export function VisibilityHandler() {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // User is leaving the tab - state is already being persisted by:
        // - usePageState (sessionStorage)
        // - React Query persister (localStorage)
        // - useScrollRestoration (sessionStorage)
        logger.info('User left tab - state is persisted');
      } else {
        // User returned - state is automatically restored by hooks
        logger.info('User returned to tab - state restored');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // This component renders nothing - it just handles visibility events
  return null;
}
